import React, { Component } from "react";
import DrillDownOrgChart from "./DrillDownOrgChart";
// import Plotly from 'plotly.js-basic-dist';
import DrillDownKpiChart from "./DrillDownKpiChart";
import axios from "../../../../axios";
import { connect } from "react-redux";
import moment from "moment";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import omitBy from "lodash/omitBy";
import isNull from "lodash/isNull";
import findIndex from "lodash/findIndex";
import find from "lodash/find";
import {
  drillDownHierarchy,
  findNodeData,
  findOfficeChart,
  findParentNode,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  chartLineColor,
  plotlyMarkerTypes,
  benchmarkLineTypes,
  dtickFormat,
} from "../../../../utils/constants";
import * as url from "../../../../utils/url";
import { getFlatDataFromTree } from "react-sortable-tree";
import html2canvas from "html2canvas";
import ReactDOM from "react-dom";
import { saveAs } from "file-saver";
import { deepClone } from "../../../../utils/copyObject";
import { generateLegendTitle } from "../../../../utils/chartUtils";
import DrillDownGuideImage from "../../../../assets/drilldownGuide.svg";

class DrillDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentOrgChart: {},
      allOrgChart: {},
      ddGuide: true,
      selectedOrgNode: {},
      currentKpiData: this.props.chartData.kpiForPlotly,
      currentBenchmarkData: this.props.chartData.benchmark,
      // selectedOffice : this.props.user.profile.officeHierarchyPath.split("#").pop(),
      selectedOffice: this.props.chartData&&this.props.chartData.selectedOffice?this.props.chartData.selectedOffice.label:'',
      drillDownLevel: 0,
      flatTree: [],
      allKpis: [],
      exportingAsPng: false,
      isNodeClicked: false,
    };
    this.chartItem = null;
  }

  chartLineMarkerGenerator = (color, type) => {
    // let value = Math.floor(Math.random()*16777215).toString(16)
    // let color = `#${value}`.toUpperCase();
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color,
        size: 10,
        symbol,
      };
    }
    return obj;
  };

  componentDidMount() {
    const {
      kpiData,
      startDate,
      kpiType,
      endDate,
      selectedOffice,
      name,
      kpiForPlotly,
    } = this.props.chartData;
    const { profile } = this.props.user;
    const { mappingMasterList } = this.props.mappingMaster;
    let { officeHierarchyPath } = profile;
    // let {officeNode}=this.props
    let officeNode = {
      id: selectedOffice.label,
      name: selectedOffice.label,
      officeKey: selectedOffice.value,
      subtitle: "",
      title: selectedOffice.label,
    };

    let officeKey = officeNode.officeKey;
    let { staticHierarchy } = this.props.user.profile.organizationId;
    // const flat = getFlatDataFromTree({
    //   treeData : staticHierarchy,
    //   getNodeKey: ({ node }) => node.officeKey,
    //   ignoreCollapsed: false
    // })
    let officeName = selectedOffice.label;
    console.log(selectedOffice, "--node--", officeNode);
    // console.log(staticHierarchy)
    // console.log(mappingMasterList,'--kpiD--', this.props);
    const kpiList = kpiData.map((kpi, i) => {
      // console.log(kpi)
      const o = {};
      o.code = kpi.kpiId.code;

      if (kpiType === "EMP_DATA_BASED") {
        // console.log('kpi stuff dd-----> ', kpi)
        if (kpi.ageStart) {
          o.ageStart = kpi.ageStart;
        }

        if (kpi.ageEnd) {
          o.ageEnd = kpi.ageEnd;
        }

        if (kpi.kpiId.code.indexOf("GRO") > -1) {
          const { performance } = mappingMasterList;
          // console.log(mappingMasterList)
          if (performance.data) {
            let pCode;
            performance.data.map((e, idx) => {
              if (o.code === e.reference.code) {
                pCode = idx;
                return pCode;
              }
            });

            let index = pCode;
            if (index !== null && index >= 0) {
              const pr = performance.data[index].values.map(o => o);
              let mappedValues = [].concat.apply([], pr);
              o.performanceList = mappedValues;
            }
            // console.log(o.performanceList)
          } else {
            // let mappedValues = [].concat.apply([],"undefined");
            o.performanceList = [undefined];
          }
        }

        if (kpi.kpiId.code.indexOf("HRT-6") > -1) {
          let mappedValues = [];
          const { separation } = mappingMasterList;
          // console.log(separation)
          separation.data.forEach(o => {
            if (o.key === "Voluntary") {
              mappedValues = o.values;
            }
          });
          // console.log(mappedValues)
          o.separationList =
            mappedValues && mappedValues.length > 0
              ? mappedValues
              : [undefined];
          // console.log(o.separationList)
        } else if (kpi.kpiId.code.indexOf("HRT-7") > -1) {
          let mappedValues = [];
          const { separation } = mappingMasterList;
          // console.log(separation)
          separation.data.forEach(o => {
            if (o.key === "Involuntary") {
              mappedValues = o.values;
            }
          });
          // console.log(mappedValues)
          o.separationList =
            mappedValues && mappedValues.length > 0
              ? mappedValues
              : [undefined];
          // console.log(o.separationList)
        }

        if (kpi.religionId) {
          const { religion } = mappingMasterList;
          let mappedValues = [];
          if (kpi.religionId === null) {
            const result = religion.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            religion.data.forEach(o => {
              if (o.reference._id === kpi.religionId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.religionList = mappedValues;
          if (kpi.religionId.name) {
            o.religionType = kpi.religionId.name;
          }
        } else {
          o.religionList = [];
          o.religionType = null;
        }

        if (kpi.ethnicityId) {
          const { ethnicity } = mappingMasterList;
          let mappedValues = [];
          if (kpi.ethnicityId === null) {
            const result = ethnicity.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            ethnicity.data.forEach(o => {
              if (o.reference._id === kpi.ethnicityId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.ethnicityList = mappedValues;
          if (kpi.ethnicityId.name) {
            o.ethnicityType = kpi.ethnicityId.name;
          }
        } else {
          o.ethnicityList = [];
          o.ethnicityType = null;
        }

        if (kpi.disabilityId) {
          const { disability } = mappingMasterList;
          let mappedValues = [];
          if (kpi.disabilityId === null) {
            const result = disability.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            disability.data.forEach(o => {
              if (o.reference._id === kpi.disabilityId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.disabilityList = mappedValues;
          if (kpi.disabilityId.name) {
            o.disabilityType = kpi.disabilityId.name;
          }
        } else {
          o.disabilityList = [];
          o.disabilityType = null;
        }

        if (kpi.sexualOrientationId) {
          const { sexualOrientation } = mappingMasterList;
          let mappedValues = [];
          if (kpi.sexualOrientationId === null) {
            const result = sexualOrientation.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            sexualOrientation.data.forEach(o => {
              if (o.reference._id === kpi.sexualOrientationId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.sexualOrientationList = mappedValues;
          if (kpi.sexualOrientationId.name) {
            o.sexualOrientationType = kpi.sexualOrientationId.name;
          }
        } else {
          o.sexualOrientationList = [];
          o.sexualOrientationType = null;
        }

        if (kpi.veteranId) {
          const { veteran } = mappingMasterList;
          let mappedValues = [];
          if (kpi.veteranId === null) {
            const result = veteran.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            veteran.data.forEach(o => {
              if (o.reference._id === kpi.veteranId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.veteranList = mappedValues;
          if (kpi.veteranId.name) {
            o.veteranType = kpi.veteranId.name;
          }
        } else {
          o.veteranList = [];
          o.veteranType = null;
        }

        if (kpi.occupationId) {
          const { occupation } = mappingMasterList;
          let mappedValues = [];
          if (kpi.occupationId.code === "ALL") {
            const result = occupation.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            occupation.data.forEach(o => {
              if (o.reference._id === kpi.occupationId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.occupationList = mappedValues;
          if (kpi.occupationId.code) {
            o.occupationCode = kpi.occupationId.code;
          }
        } else {
          o.occupationList = [];
          o.occupationCode = "NONE";
        }

        if (kpi.seniorityId) {
          const { seniority } = mappingMasterList;
          let mappedValues = [];
          if (kpi.seniorityId.code === "ALL") {
            const result = seniority.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            seniority.data.forEach(o => {
              if (o.reference._id === kpi.seniorityId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.seniorityList = mappedValues;
          if (kpi.seniorityId.code) {
            o.seniorityCode = kpi.seniorityId.code;
          }
        } else {
          o.seniorityList = [];
          o.seniorityCode = "NONE";
        }
        if (kpi.location) {
          o.location = kpi.location;
        }
      }
      if (kpi.diversityType) {
        o.diversityType = kpi.diversityType;
      }
      return o;
    });
    const { gender } = mappingMasterList;

    const maleList = find(
      gender.data,
      o => o.key === "MALE" || o.key === "Male"
    ).values;
    const femaleList = find(
      gender.data,
      o => o.key === "FEMALE" || o.key === "Female"
    ).values;
    let otherList = [];
    let pntsList = [];
    let nBnList = [];
    if (find(gender.data, { key: "OTHER" })) {
      otherList = find(gender.data, { key: "OTHER" }).values;
    }
    if (find(gender.data, { key: "Prefer not to specify" })) {
      pntsList = find(gender.data, { key: "Prefer not to specify" }).values;
    }
    if (find(gender.data, { key: "NON-BINARY" })) {
      nBnList = find(gender.data, { key: "NON-BINARY" }).values;
    }
    // console.log(officeNode)
    let allOfficeKeys = drillDownHierarchy(staticHierarchy, officeNode);
    // console.log(this.state, this.props)
    // console.log('---alllOfficeKeys---')
    // console.log(allOfficeKeys)
    // const kpiNames = kpiData.map((kpi) => kpi.kpiId.name);
    const kpiDescription = kpiForPlotly.map(kpi => kpi.name);
    console.log(kpiDescription, kpiForPlotly);
    const payload = omitBy(
      {
        officeHierarchyPath: officeHierarchyPath,
        officeHierarchyName: officeName,
        allOfficeKeys,
        officeKey:
          officeNode.officeKey && officeNode.officeKey !== undefined
            ? officeNode.officeKey
            : allOfficeKeys.initialOfficeKey,
        kpiList: kpiList,
        startDate: startDate,
        kpiType: kpiType,
        maleList: maleList,
        femaleList: femaleList,
        otherList: otherList,
        pntsList,
        nBnList,
        mappingMasterList,
        endDate: endDate ? endDate : null,
        chartId:this.props.chartData._id
      },
      isNull
    );

    axios.post(url.getHierarchyData, payload).then(({ data }) => {
      console.log(data.data);
      const serverData = deepClone(data.data);
      const payload = this.setParentChildTags(serverData);
      const allOrgChart = this.convertFlatDataToTree(serverData, officeKey);
      console.log(payload);
      console.log(allOrgChart);
      this.setState({
        currentOrgChart: payload,
        allOrgChart: allOrgChart,
        // allKpis : kpiNames,
        allKpis: kpiDescription,
        kpiType: kpiType,
        // flatTree:flat
      });
    });
  }

  convertFlatDataToTree = (flat, officeKey) => {
    const data = { ...flat };
    data.path = officeKey;
    data.employeeCount = flat.employeeCount;
    const children = flat.officePath
      .filter(o => o.officeKey !== officeKey)
      .map(child => {
        console.log(child);
        if (child.children) {
          child.children = null;
        }
        return child;
      });
    data.children = children;
    console.log(data);
    return data;
  };

  setParentChildTags = tree => {
    // console.log(tree);
    let data = { ...tree };
    data.isParent = true;
    let isRootOffice = false;
    if (data.officePath) {
      isRootOffice = true;
    }
    console.log("--data--", data);
    if (isRootOffice) {
      // console.log('root office')
      data.path = tree.currentOffice;
      data.kpi = find(data.officePath, o => o.officeKey === tree.officeKey).kpi;
      data.employeeCount = find(
        data.officePath,
        o => o.officeKey === tree.officeKey
      ).employeeCount;
      const children = data.officePath
        .filter(o => o.officeKey !== tree.officeKey)
        .map(child => {
          child.isChild = true;
          if (child.children) {
            child.children = null;
          }
          return child;
        });
      data.children = children;
    } else {
      data.kpi = tree.kpi;
      data.path = tree.currentOffice;
      // console.log('---not root office---', data)
      let children = [];
      if (data.children && data.children.length > 0) {
        children = data.children.map(child => {
          child.isChild = true;
          if (child.children) {
            child.children = null;
          }
          return child;
        });
      } else {
        if (tree && tree.children_temp) {
          children = [tree.children_temp];
        }
      }
      data.children = children;
    }
    // console.log('setParent---', data)
    return data;
  };

  handleNodeClick = node => {
    console.log(node);
    const chartBenchmark = this.props.chartData.benchmarkData;
    const kpiData = this.processKpiData(node.kpi);
    // const officeName = node.path.split("#").pop();
    const officeName = node.name;
    this.setState({
      currentKpiData: kpiData,
      selectedOffice: officeName,
      isNodeClicked: true,
      ddGuide: false,
    });
  };

  handleDrillDownClick = node => {
    // console.log(this.props)
    // console.log(this.props.mappingMaster)
    const { kpiData, startDate, endDate, kpiForPlotly } = this.props.chartData;
    const { mappingMasterList } = this.props.mappingMaster;

    let { staticHierarchy } = this.props.user.profile.organizationId;

    const { allOrgChart, drillDownLevel, currentOrgChart, kpiType } =
      this.state;
    // console.log(mappingMasterList, kpiData);
    const kpiList = kpiData.map((kpi, i) => {
      // console.log(kpi)
      const o = {};
      o.code = kpi.kpiId.code;

      if (kpiType === "EMP_DATA_BASED") {
        // console.log('kpi stuff dd-----> ', kpi)
        if (kpi.ageStart) {
          o.ageStart = kpi.ageStart;
        }

        if (kpi.ageEnd) {
          o.ageEnd = kpi.ageEnd;
        }

        if (kpi.kpiId.code.indexOf("GRO") > -1) {
          const { performance } = mappingMasterList;
          // console.log(mappingMasterList)
          if (performance.data) {
            let pCode;
            performance.data.map((e, idx) => {
              if (o.code === e.reference.code) {
                pCode = idx;
                return pCode;
              }
            });

            let index = pCode;
            if (index !== null && index >= 0) {
              const pr = performance.data[index].values.map(o => o);
              let mappedValues = [].concat.apply([], pr);
              o.performanceList = mappedValues;
            }
            // console.log(o.performanceList)
          } else {
            // let mappedValues = [].concat.apply([],"undefined");
            o.performanceList = [undefined];
          }
        }

        if (kpi.kpiId.code.indexOf("HRT-6") > -1) {
          let mappedValues = [];
          const { separation } = mappingMasterList;
          // console.log(separation)
          separation.data.forEach(o => {
            if (o.key === "Voluntary") {
              mappedValues = o.values;
            }
          });
          // console.log(mappedValues)
          o.separationList =
            mappedValues && mappedValues.length > 0
              ? mappedValues
              : [undefined];
          // console.log(o.separationList)
        } else if (kpi.kpiId.code.indexOf("HRT-7") > -1) {
          let mappedValues = [];
          const { separation } = mappingMasterList;
          // console.log(separation)
          separation.data.forEach(o => {
            if (o.key === "Involuntary") {
              mappedValues = o.values;
            }
          });
          // console.log(mappedValues)
          o.separationList =
            mappedValues && mappedValues.length > 0
              ? mappedValues
              : [undefined];
          // console.log(o.separationList)
        }

        if (kpi.religionId) {
          const { religion } = mappingMasterList;
          let mappedValues = [];
          if (kpi.religionId === null) {
            const result = religion.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            religion.data.forEach(o => {
              if (o.reference._id === kpi.religionId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.religionList = mappedValues;
          if (kpi.religionId.name) {
            o.religionType = kpi.religionId.name;
          }
        } else {
          o.religionList = [];
          o.religionType = null;
        }

        if (kpi.ethnicityId) {
          const { ethnicity } = mappingMasterList;
          let mappedValues = [];
          if (kpi.ethnicityId === null) {
            const result = ethnicity.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            ethnicity.data.forEach(o => {
              if (o.reference._id === kpi.ethnicityId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.ethnicityList = mappedValues;
          if (kpi.ethnicityId.name) {
            o.ethnicityType = kpi.ethnicityId.name;
          }
        } else {
          o.ethnicityList = [];
          o.ethnicityType = null;
        }

        if (kpi.disabilityId) {
          const { disability } = mappingMasterList;
          let mappedValues = [];
          if (kpi.disabilityId === null) {
            const result = disability.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            disability.data.forEach(o => {
              if (o.reference._id === kpi.disabilityId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.disabilityList = mappedValues;
          if (kpi.disabilityId.name) {
            o.disabilityType = kpi.disabilityId.name;
          }
        } else {
          o.disabilityList = [];
          o.disabilityType = null;
        }

        if (kpi.sexualOrientationId) {
          const { sexualOrientation } = mappingMasterList;
          let mappedValues = [];
          if (kpi.sexualOrientationId === null) {
            const result = sexualOrientation.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            sexualOrientation.data.forEach(o => {
              if (o.reference._id === kpi.sexualOrientationId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.sexualOrientationList = mappedValues;
          if (kpi.sexualOrientationId.name) {
            o.sexualOrientationType = kpi.sexualOrientationId.name;
          }
        } else {
          o.sexualOrientationList = [];
          o.sexualOrientationType = null;
        }

        if (kpi.veteranId) {
          const { veteran } = mappingMasterList;
          let mappedValues = [];
          if (kpi.veteranId === null) {
            const result = veteran.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            veteran.data.forEach(o => {
              if (o.reference._id === kpi.veteranId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.veteranList = mappedValues;
          if (kpi.veteranId.name) {
            o.veteranType = kpi.veteranId.name;
          }
        } else {
          o.veteranList = [];
          o.veteranType = null;
        }

        //   if(kpi.ageStart!=null&&kpi.ageEnd!=null){
        //     o.ageStart = kpi.ageStart
        //     o.ageEnd = kpi.ageEnd
        // } else if(kpi.ageStart!=null){
        //     o.ageStart = kpi.ageStart
        // } else if(kpi.ageEnd!=null){
        //     o.ageEnd = kpi.ageEnd
        // }

        if (kpi.occupationId) {
          const { occupation } = mappingMasterList;
          let mappedValues = [];
          if (kpi.occupationId.code === "ALL") {
            const result = occupation.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            occupation.data.forEach(o => {
              if (o.reference._id === kpi.occupationId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.occupationList = mappedValues;
          if (kpi.occupationId.code) {
            o.occupationCode = kpi.occupationId.code;
          }
        } else {
          o.occupationList = [];
          o.occupationCode = "NONE";
        }

        if (kpi.seniorityId) {
          const { seniority } = mappingMasterList;
          let mappedValues = [];
          if (kpi.seniorityId.code === "ALL") {
            const result = seniority.data.map(o => o.values);
            mappedValues = [].concat.apply([], result);
          } else {
            seniority.data.forEach(o => {
              if (o.reference._id === kpi.seniorityId._id) {
                mappedValues = o.values;
              }
            });
          }
          o.seniorityList = mappedValues;
          if (kpi.seniorityId.code) {
            o.seniorityCode = kpi.seniorityId.code;
          }
        } else {
          o.seniorityList = [];
          o.seniorityCode = "NONE";
        }
        if (kpi.location) {
          o.location = kpi.location;
        }
      }
      if (kpi.diversityType) {
        o.diversityType = kpi.diversityType;
      }
      return o;
    });
    const { gender } = mappingMasterList;
    const maleList = find(
      gender.data,
      o => o.key === "MALE" || o.key === "Male"
    ).values;
    const femaleList = find(
      gender.data,
      o => o.key === "FEMALE" || o.key === "Female"
    ).values;
    let otherList = [];
    if (find(gender.data, { key: "OTHER" })) {
      otherList = find(gender.data, { key: "OTHER" }).values;
    }

    let allOfficeKeys = drillDownHierarchy(staticHierarchy, node);

    const kpiDescription = kpiForPlotly.map(kpi => kpi.name);
    const payload = omitBy(
      {
        officeHierarchyPath: node.path,
        officeHierarchyName: node.name,
        allOfficeKeys,
        officeKey: node.officeKey,
        kpiList: kpiList,
        startDate: startDate,
        kpiType: kpiType,
        maleList: maleList,
        femaleList: femaleList,
        otherList: otherList,
        endDate: endDate ? endDate : null,
      },
      isNull
    );
    axios.post(url.getHierarchyData, payload).then(({ data }) => {
      if (data.data.officePath.length > 1) {
        console.log(node, data.data);
        const payload = this.setParentChildTags(data.data);
        const nodeWithPath = this.findNodeWithPath(allOrgChart, node.officeKey);
        const treeData = this.convertFlatDataToTree(data.data, node.officeKey);
        // nodeWithPath.children = treeData.children;
        this.setState({
          currentOrgChart: payload,
          drillDownLevel: drillDownLevel + 1,
          // allOrgChart : {...allOrgChart}
        });
      } else {
        const { children } = currentOrgChart;
        const child = find(children, { path: node.path });
        child.isLeafNode = true;
        this.setState({
          currentOrgChart: { ...currentOrgChart },
        });
      }
    });
  };

  processKpiData = (kpiData, type) => {
    const { allKpis, kpiType } = this.state;
    let dtickFormatVal, xMinDate, xMaxDate;
    // console.log("inReponse", allKpis,kpiType);
    if (kpiType === "SURVEY_BASED") {
      // console.log('hiii', kpiData)
      const allKpiValues = [];
      let i = 0;
      const kpi = kpiData.map((kpiInput, i) => {
        let chartColor = chartLineColor(i);
        for (let key in kpiInput) {
          const serverKpiData = kpiInput[key];
          if (serverKpiData && serverKpiData.length > 0) {
            const sortedKpiAggregate = reverse(
              sortBy(serverKpiData, kpi => kpi.selectedDate)
            );
            const singleKpi = sortedKpiAggregate.length === 1;
            const kpi = {
              name: allKpis[i],
              y: sortedKpiAggregate.map(kpi => Math.round(kpi.score) / 100),
              x: sortedKpiAggregate.map(kpi => {
                //return sortBy(
                return kpi.selectedDate;
                // return moment(kpi.selectedDate).format("MMM DD, YYYY")
                //  return  moment(kpi.selectedDate).utcOffset(0).format("MMM DD, YYYY")
                //);
              }),
              type: "scatter",
              // line:plotlyLineTypes[i],
              line: this.chartLineMarkerGenerator(chartColor, "line"),
              marker: this.chartLineMarkerGenerator(chartColor, "marker"),
              // marker: singleKpi ? plotlyMarkerTypes[i] : plotlyMarkerTypes[i],
              xaxis: "x",
              yaxis: "y",
              id: i,
            };
            allKpiValues.push(kpi);
            i++;
          }
        }
      });
      return allKpiValues;
    } else {
      const kpi = kpiData? kpiData.map((kpi, i) => {
        // console.log('kpi --- ',kpi)

        let chartColor = chartLineColor(i);

        const sortedKpiAggregate = sortBy(kpi, kpi => kpi.isoDate);
        const singleKpi = sortedKpiAggregate.length === 1;
        const parentKpiData = this.props.chartData.kpiData;
        // console.log('sorted---->', sortedKpiAggregate)

        let text = sortedKpiAggregate.map(k => {
          // console.log(k)

          let val = k.data;
          if (val && val.numeratorType && val.totalEmployees) {
            if (k.kpiCode === "COMP-1" || k.kpiCode === "COMP-2") {
              return `${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}, male count: ${
                val.totalEmployees
                  ? val.totalEmployees - val.numeratorCount
                  : null
              }`;
            } else {
              return `${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}, total: ${
                val.totalEmployees ? val.totalEmployees : null
              }`;
            }
          } else if (val && val.numeratorType && !val.totalEmployees) {
            return `${val.numeratorType
              .substring(1)
              .replace(/-/g, ", ")
              .toLowerCase()} count: ${val.numeratorCount}`;
          } else if (val.totalEmployees && !val.numeratorType) {
            return `of total: ${
              val.totalEmployees ? val.totalEmployees : null
            }`;
          } else {
            return null;
          }
        });
        let x = sortedKpiAggregate.map(kpi => {
          //return sortBy(
          // return moment(kpi.isoDate).format("YYYY-MM-DD HH:mm:ss.SSS")
          // return moment(kpi.isoDate).format("MMM DD, YYYY")
          // return moment(kpi.isoDate).utcOffset(0).format("MMM DD, YYYY")
          let date1 = moment.utc(kpi.isoDate).format("YYYY-MM-DD");
          if (xMinDate == undefined || xMinDate > date1) {
            xMinDate = date1;
          }

          if (xMaxDate == undefined || date1 > xMaxDate) {
            xMaxDate = date1;
          }
          return date1;
          //);
        });

        dtickFormatVal = dtickFormat(xMinDate, xMaxDate);

        let description = generateLegendTitle(
          parentKpiData[i],
          parentKpiData[i].kpiId.description,
          i,
          false,
          "",
          ""
        );
        return {
          // name : generateLegendTitle(parentKpiData[i],parentKpiData[i].kpiId.description, i, false, "", ""),
          name: description,
          description: description,
          y: sortedKpiAggregate.map(kpi => kpi.score / 100),
          x,
          text,
          type: "scatter",
          // hovertemplate:  "<b>%{text[0]}</b>, " + `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>`+
          // "%{text[1]}<br>" +
          // "%{text[2]}<br>" +
          // "<extra></extra>",
          // line:plotlyLineTypes[i],
          // marker: singleKpi ? plotlyMarkerTypes[i] : plotlyMarkerTypes[i],
          line: this.chartLineMarkerGenerator(chartColor, "line"),
          marker: this.chartLineMarkerGenerator(chartColor, "marker"),
          yaxis: "y",
          id: i,
          lines: "scatter",
          mode: "lines+markers",
        };
      }):[]
      kpi.dtickFormat = dtickFormatVal;
      kpi.xMaxDate = xMaxDate;
      kpi.xMinDate = xMinDate;
      return kpi;
    }
  };

  processBenchmarkData = benchmarkData => {
    ////console.log("NEEDS DATA");
    ////console.log(benchmarkData);
    let benchmark = {};
    const { dataArr } = benchmarkData;
    let sortedDataArray = sortBy(dataArr, data => data.date);
    const singleBenchmark = sortedDataArray.length === 1;
    // benchmark.name = `${benchmarkData.kpi.kpiId} (Benchmark)`;
    benchmark.x = sortedDataArray.map(benchmark =>
      moment(benchmark.date).format("MMM DD, YYYY")
    );
    benchmark.y = sortedDataArray.map(benchmark => benchmark.score / 100);
    benchmark.type = "scatter";
    benchmark.line = benchmarkLineTypes[0];
    benchmark.marker = singleBenchmark
      ? plotlyMarkerTypes[3]
      : plotlyMarkerTypes[0];
    benchmark.xaxis = "x";
    benchmark.yaxis = "y";
    return benchmark;
  };

  handleExportAsPng = () => {
    console.log(this.state, this.chartItem);
    let { selectedOffice } = this.state;

    let nodeClone = ReactDOM.findDOMNode(this.chartItem);
    console.log(nodeClone);

    // this.setState({
    //   exportingAsPng : true
    // });

    let imageTitle = `${selectedOffice} - ${moment(new Date()).format(
      "MM-D-YYYY"
    )}`;
    // let chartNode = node.querySelector('.kpiCharts')

    html2canvas(nodeClone).then(canvas => {
      canvas.toBlob(function (blob) {
        // blob ready, download it
        let link = document.createElement("a");
        link.download = imageTitle;

        link.href = URL.createObjectURL(blob);
        link.click();

        // delete the internal blob reference, to let the browser clear memory from it
        URL.revokeObjectURL(link.href);
      }, "image/png");
    });

    // Plotly.downloadImage(chartNode, {
    //   format: 'svg',
    //   height: null,
    //   width: null,
    //   scale: 1,
    //   filename: `${chartname}`

    // });

    // html2canvas(node).then((canvas) => {

    //   console.log('canvas---',canvas)

    //   canvas.toBlob((blob) => {

    //     console.log('blob----',blob)

    //     saveAs(blob, chartname);

    //     // this.setState({
    //     //   exportingAsPng : false
    //     // });
    //   });
    // });
  };

  handleDrillUpClick = node => {
    const { allOrgChart, drillDownLevel } = this.state;

    let { staticHierarchy } = this.props.user.profile.organizationId;

    let parentData = findParentNode(staticHierarchy, node);
    console.log(parentData);
    let parentNode = this.findNodeWithPath(allOrgChart, parentData.officeKey);
    console.log(parentNode);

    parentNode = { ...parentNode, children_temp: node };
    console.log(node, allOrgChart);
    this.setState({
      currentOrgChart: this.setParentChildTags(parentNode),
      drillDownLevel: drillDownLevel - 1,
    });
  };

  findNodeWithPath = (node, officeKey) => {
    console.log(node);
    console.log(officeKey);
    let found = false;
    let foundNode;
    if (Array.isArray(node)) {
      const i = findIndex(node, n => n.officeKey === officeKey);
      if (i > -1) {
        found = true;
        foundNode = node[i];
      }
    } else {
      found = node.officeKey === officeKey;
      if (found) {
        foundNode = node;
      }
    }
    if (found) {
      console.log(foundNode);
      return foundNode;
    } else {
      if (Array.isArray(node)) {
        for (let k = 0; k < node.length; k++) {
          if (node[k].children) {
            return this.findNodeWithPath(node[k].children, officeKey);
          }
        }
      } else {
        return this.findNodeWithPath(node.children, officeKey);
      }
    }
  };

  render() {
    // console.log(this.props.chartData);
    // //console.log(this.state.currentOrgChart);
    //console.log(this.state);
    console.log(this.state, this.props);
    const {
      currentOrgChart,
      currentKpiData,
      exportingAsPng,
      currentBenchmarkData,
      selectedOffice,
      drillDownLevel,
      allKpis,
      kpiType,
    } = this.state;
    const { profile } = this.props.user;
    let isSelfOffice = false;
    // console.log(profile)
    // const myOffice = profile.officeHierarchyPath.split('#').pop();
    // if(selectedOffice.value === myOffice) {
    //   isSelfOffice = true;
    // }
    // console.log(this.state)
    return (
      <div>
        <div className="drill-down-modal-title">
          Drill Down into the Analytics
        </div>
        <div className="drill-down-modal-help">
          <span className="info-msg-bg">
            <b> NOTE </b>: KPIs in boxes represent latest values in the date
            range selected.
          </span>
        </div>
        <DrillDownOrgChart
          orgChart={currentOrgChart}
          drillDownLevel={drillDownLevel}
          allKpis={allKpis}
          selectedOffice={selectedOffice}
          onNodeClick={this.handleNodeClick}
          onDrillDownClick={this.handleDrillDownClick}
          onDrillUpClick={this.handleDrillUpClick}
          kpiType={kpiType}
          chart={this.props.chartData}
        />

        <hr style={{ marginTop: "0px", marginBottom: "0px" }} />
        {this.state.ddGuide ? (
          <div className="drill-down-modal-guide">
            <div className="drillDownImageDes">
              Click on one of the boxes above to see the chart for the selected
              office in your organization, OR click the tab below each office to
              drill down one level further.
            </div>
            <div style={{ textAlign: "center" }}>
              <img className="drillDownImage" src={DrillDownGuideImage} />
            </div>
          </div>
        ) : (
          <DrillDownKpiChart
            ref={r => (this.chartItem = r)}
            yRange={this.props.yRange}
            kpiData={currentKpiData}
            benchmarkData={
              currentBenchmarkData && currentBenchmarkData != undefined
                ? currentBenchmarkData
                : []
            }
            selectedOffice={selectedOffice} 
            isNodeClicked={this.state.isNodeClicked}
            chart={this.props.chartData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    mappingMaster: state.mappingMaster,
  };
};

export default connect(mapStateToProps)(DrillDown);
